"use client";

import * as Sentry from "@sentry/nextjs";
import {useEffect} from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html>
      <body className="bg-black text-white">
        <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-6">
          <h1 className="text-6xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            500
          </h1>
          <p className="text-white/60 text-lg text-center max-w-md">
            Something went wrong. The error has been reported.
          </p>
          <button
            onClick={reset}
            className="px-6 py-3 rounded-xl bg-purple-600 hover:bg-purple-500 text-white font-semibold transition"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
